import { combineReducers } from 'redux';
import config from './config';
import profile from './profile';
import loading from './loading';

export default combineReducers({
    config,
    profile,
    loading
})